// composables/useBreadcrumb.js
import { ref, watch, computed, getCurrentInstance } from "vue";

// Rutas donde se muestra el breadcrumb en lugar de flecha + título
const breadcrumbRoutes = [
  "/actuaciones/list",
  "/actuaciones/view",
  "/calabozo",
  "/sifcop",
  "/parametros/juzgados",
  "/parametros/departamentales",
  "/parametros/deposito-dependencia",
  "/parametros/genero",
  "/parametros/personal-fiscal",
  "/parametros/estadocivil",
  "/parametros/provincias",
  "/parametros/paises",
  "/parametros/categorias",
  "/parametros/sub-categorias",
  "/parametros/marcas",
  "/parametros/articulos",
  "/parametros/list",
  "/parametros/dependencia",
  "/parametros/caratula",
  "/parametros/sitio",
  "/parametros/tipo-moneda",
  "/parametros/modus-operandi",
  "/parametros/gestor-archivos",
];

export function useBreadcrumb() {
  const internalInstance = getCurrentInstance();
  if (!internalInstance) {
    throw new Error("useBreadcrumb must be called within setup.");
  }

  const proxy = internalInstance.proxy;
  const route = ref(proxy.$route);

  watch(
    () => proxy.$route,
    (newRoute) => {
      route.value = newRoute;
    }
  );

  const shouldShowBreadcrumb = computed(() => {
    const currentPath = route.value?.path || "";
    return breadcrumbRoutes.some((routePath) => currentPath.startsWith(routePath));
  });

  return {
    shouldShowBreadcrumb,
  };
}
